const module = { name: 'Fandango/carousel', exports: {} }; const exports = module.exports;



import { Splide as Splide } from 'require-core';



const Selectors = {
    ARROW_LEFT: '.js-fd-carousel-arrow-left',
    ARROW_RIGHT: '.js-fd-carousel-arrow-right',
    FOCUSABLE_ELEMENT: '.js-fd-carousel-focus-elem',
    PLACEHOLDER: '.js-fd-carousel-placeholder',
    SLIDE: '.splide__slide',
    SPLIDE: '.js-fd-splide'
}


const Styles = {
    HIDE: 'hide',
    IS_FOCUSED: 'is-focused',
    IS_VISIBLE: 'is-visible',
    LAST_SELECTED: 'fd-carousel--last-selected',
}


const KeyCodes = {
    ENTER: 'Enter',
    SPACE: 'Space',
    TAB: 'Tab'
}


const Types = {
    LOOP: 'loop',
    SLIDE: 'slide'
}


const defaultOpts = {
    arrows: false,
    autoplay: false,
    autoWidth: false,
    gap: 20,
    goToIndexOnClick: false,
    hasGradient: false,
    keyboard: 'focused',
    padding: { left: 20, right: 20 },
    pagination: false,
    perPage: 3,
    setSelected: false,
    slideFocus: false,
    speed: 500,
    type: Types.SLIDE,
}


const carouselContexts = {
    contexts: {},
    get(id) {
        return this.contexts[id];
    },
    add(id, opts) {
        const existing = this.get(id);
        const container = document.querySelector(`#${id}`);
        if (existing && (existing === container)) {
            return existing;
        }
        return this.contexts[id] = {
            carouselInstance: null,
            container,
            elem: container?.querySelector(Selectors.SPLIDE),
            hasBleedingLeft: null,
            hasBleedingRight: null,
            isEnterOrSpace: null,
            isTabbed: null,
            retainFocus: null,
            visibleItems: null,
            options: {
                ...defaultOpts,
                ...opts,
            },
        };
    }
}
function removePlaceholder(id) {
    const context = carouselContexts.get(id);
    const placeholder = context.container.querySelector(Selectors.PLACEHOLDER);
    if (!placeholder) {
        return;
    }
    placeholder.classList.add(Styles.HIDE);
    context.elem.classList.remove(Styles.HIDE);
}
function getKeyEvent(event) {
    return {
        enterOrSpace: event.code === KeyCodes.ENTER || event.code === KeyCodes.SPACE,
        tab: event.code === KeyCodes.TAB
    };
}
function applyFocusClass(context) {
    const activeSlide = document.activeElement.closest(Selectors.SLIDE);
    context.slides.forEach((slide) => {
        removeFocusClass(slide);
    });
    activeSlide && activeSlide.classList.add(Styles.IS_FOCUSED);
}
function onKeyup(id) {
    const context = carouselContexts.get(id);
    context.elem.addEventListener('keyup', (event) => {
        const { tab, enterOrSpace } = getKeyEvent(event);
        context.isEnterOrSpace = enterOrSpace;
        context.isTabbed = tab;
        applyFocusClass(context);
    });
}
function moveCarousel(direction, id, distance = '') {
    carouselContexts.get(id).carouselInstance.go(`${direction}${distance}`);
}
function shiftLeft() {
    const id = this.dataset.carouselId;
    const context = carouselContexts.get(id);
    if (context.isTabbed) {
        context.retainFocus = true;
        moveCarousel('-', id);
    }
}
function shiftRight() {
    const id = this.dataset.carouselId;
    const context = carouselContexts.get(id);
    if (context.isTabbed) {
        context.retainFocus = true;
        moveCarousel('+', id);
    }
}
function onArrowClick(direction, id) {
    const context = carouselContexts.get(id);
    context.retainFocus = false;
    moveCarousel(direction, id, context.options.perPage);
}
function setArrows(id) {
    const context = carouselContexts.get(id);
    if (context.options.type === Types.LOOP) {
        const totalSlides = context.slides ? context.slides.length : 0;
        const hasMultipleSlides = totalSlides > 1;
        context.arrowLeft.disabled = !hasMultipleSlides;
        context.arrowRight.disabled = !hasMultipleSlides;
        setGradient(id);
        return;
    }
    if (context.hasBleedingLeft) {
        context.arrowLeft.disabled = false;
    }
    else {
        context.arrowLeft.disabled = context.carouselInstance.index === 0 || context.visibleItems.length === context.slides.length;
    }
    if (context.hasBleedingRight) {
        context.arrowRight.disabled = false;
    }
    else {
        context.arrowRight.disabled = context.carouselInstance.index + context.options.perPage >= context.slides.length;
    }
    setGradient(id);
}
function checkVisibility(slide, id) {
    const context = carouselContexts.get(id);
    const trackRect = context.carouselInstance.Components.Elements.track.getBoundingClientRect();
    const slideRect = slide.getBoundingClientRect();
    const isWithinLeft = slideRect.left >= trackRect.left;
    const isWithinRight = slideRect.right <= trackRect.right;
    const isBleedingLeft = (slideRect.left < trackRect.left) && (slideRect.right > trackRect.left);
    const isBleedingRight = (slideRect.left < trackRect.right) && (slideRect.right > trackRect.right);
    return {
        isVisible: (isWithinLeft || isBleedingLeft) && (isWithinRight || isBleedingRight),
        isBleedingLeft,
        isBleedingRight
    };
}
function applyFocus(id) {
    const context = carouselContexts.get(id);
    if (context.isEnterOrSpace && !context.retainFocus) {
        context.visibleItems[0] && context.visibleItems[0].focus();
        context.retainFocus = false;
        context.isEnterOrSpace = false;
    }
}
function addFocusClass() {
    this.closest(Selectors.SLIDE).classList.add(Styles.IS_FOCUSED);
}
function removeFocusClass(element) {
    element.closest(Selectors.SLIDE).classList.remove(Styles.IS_FOCUSED);
}
function setTabFocus(id) {
    const context = carouselContexts.get(id);
    let hasBleedingLeft = false;
    let hasBleedingRight = false;
    context.visibleItems = [];
    context.container.querySelectorAll(Selectors.SLIDE).forEach((slide) => {
        const { isVisible, isBleedingLeft, isBleedingRight } = checkVisibility(slide, id);
        const focusableElements = [...slide.querySelectorAll(Selectors.FOCUSABLE_ELEMENT)];
        const firstFocusableElement = focusableElements[0] || slide;
        slide.setAttribute('aria-hidden', `${!isVisible}`);
        firstFocusableElement.dataset.carouselId = id;
        firstFocusableElement.addEventListener('focus', addFocusClass);
        firstFocusableElement.removeEventListener('focus', shiftLeft);
        firstFocusableElement.removeEventListener('focus', shiftRight);
        if (isVisible) {
            context.visibleItems.push(firstFocusableElement);
        }
        if (isBleedingLeft) {
            hasBleedingLeft = true;
            firstFocusableElement.addEventListener('focus', shiftLeft);
        }
        if (isBleedingRight) {
            hasBleedingRight = true;
            firstFocusableElement.addEventListener('focus', shiftRight);
        }
        focusableElements.forEach((element) => {
            element.setAttribute('tabindex', isVisible ? 0 : -1);
        });
    });
    context.hasBleedingLeft = hasBleedingLeft;
    context.hasBleedingRight = hasBleedingRight;
}
function onMounted(id) {
    const context = carouselContexts.get(id);
    Object.assign(context, {
        arrowLeft: context.elem.querySelector(Selectors.ARROW_LEFT),
        arrowRight: context.elem.querySelector(Selectors.ARROW_RIGHT),
        slides: context.carouselInstance.Components.Elements.slides,
        gradientLeft: context.elem.querySelector('.js-fd-gradient-left'),
        gradientRight: context.elem.querySelector('.js-fd-gradient-right')
    });
    if (context.options.setSelected) {
        context.carouselInstance.on('click', (slide) => {
            context.slides.forEach((slideElement) => {
                const child = slideElement.firstElementChild;
                if (child) {
                    child.classList.remove(Styles.LAST_SELECTED);
                }
            });
            const clickedSlideChild = slide.slide.firstElementChild;
            if (clickedSlideChild) {
                clickedSlideChild.classList.add(Styles.LAST_SELECTED);
                if (context.options.goToIndexOnClick) {
                    context.carouselInstance.go(slide.index);
                }
            }
        });
        if (typeof context.options.start === 'number') {
            const initiallySelectedSlide = context.slides[context.options.start];
            if (initiallySelectedSlide) {
                const initiallySelectedChild = initiallySelectedSlide.firstElementChild;
                if (initiallySelectedChild) {
                    initiallySelectedChild.classList.add(Styles.LAST_SELECTED);
                }
            }
        }
    }
    if (context.options.hasGradient && context.options.type === Types.SLIDE) {
        if (!context.gradientLeft) {
            const left = document.createElement('div');
            left.className = 'fd-gradient fd-gradient--left js-fd-gradient-left';
            left.setAttribute('aria-hidden', 'true');
            const leftBtn = context.elem.querySelector(Selectors.ARROW_LEFT);
            (leftBtn?.nextSibling)
                ? leftBtn.parentNode.insertBefore(left, leftBtn.nextSibling)
                : context.elem.appendChild(left);
            context.gradientLeft = left;
        }
        if (!context.gradientRight) {
            const right = document.createElement('div');
            right.className = 'fd-gradient fd-gradient--right js-fd-gradient-right';
            right.setAttribute('aria-hidden', 'true');
            const rightBtn = context.elem.querySelector(Selectors.ARROW_RIGHT);
            rightBtn
                ? rightBtn.parentNode.insertBefore(right, rightBtn)
                : context.elem.appendChild(right);
            context.gradientRight = right;
        }
    }
    context.arrowLeft.addEventListener('click', () => onArrowClick('-', id));
    context.arrowRight.addEventListener('click', () => onArrowClick('+', id));
    removePlaceholder(id);
    onKeyup(id);
    setTimeout(() => {
        setTabFocus(id);
        const { hasBleedingLeft, hasBleedingRight, visibleItems } = context;
        const perPage = visibleItems.length - (hasBleedingLeft ? 1 : 0) - (hasBleedingRight ? 1 : 0);
        context.options.perPage = perPage;
        if (perPage < context.carouselInstance.length) {
            context.carouselInstance.options = { perPage };
            context.carouselInstance.refresh();
            setTabFocus(id);
        }
        setArrows(id);
        setGradient(id);
    }, 100);
}
function onMoved(id) {
    setTabFocus(id);
    setArrows(id);
    applyFocus(id);
    setGradient(id);
}
function setGradient(id) {
    const context = carouselContexts.get(id);
    if (!context?.options?.hasGradient) {
        return;
    }
    const left = context.gradientLeft || context.elem.querySelector('.js-fd-gradient-left');
    const right = context.gradientRight || context.elem.querySelector('.js-fd-gradient-right');
    if (!left && !right) {
        return;
    }
    const isMobileContainer = context.container?.classList?.contains('movie-carousel--mobile');
    if (isMobileContainer || context.options.type !== Types.SLIDE) {
        left && left.classList.remove(Styles.IS_VISIBLE);
        right && right.classList.remove(Styles.IS_VISIBLE);
        return;
    }
    const index = context.carouselInstance.index;
    const visibleCount = context.visibleItems?.length || 0;
    const total = context.slides ? context.slides.length : 0;
    const moreToLeft = context.hasBleedingLeft || index > 0;
    const moreToRight = context.hasBleedingRight || (index + visibleCount) < total;
    left && left.classList.toggle(Styles.IS_VISIBLE, moreToLeft);
    right && right.classList.toggle(Styles.IS_VISIBLE, moreToRight);
}
function init(id, opts = {}) {
    const context = carouselContexts.add(id, opts);
    if (!context.elem) {
        return;
    }
    context.carouselInstance = new Splide(`#${id} ${Selectors.SPLIDE}`, context.options);
    context.carouselInstance.on('mounted', () => onMounted(id));
    context.carouselInstance.mount();
    const callback = () => onMoved(id);
    context.carouselInstance
        .on('moved', callback)
        .on('resized', callback)
        .on('updated', callback);
}
module.exports = {
    init,
    getInstance(id) {
        return carouselContexts.get(id)?.carouselInstance;
    }
};
export default module.exports;